<template>
  <div class="mit-network-page mit-page">
    <v-snackbar top :color="status.color" min-width="0" v-model="status.display" :timeout="status.timeout">
        <b>{{ status.message }}</b>
    </v-snackbar>
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Settings</v-card-title>
            <v-card-subtitle class="caption">My CSAIL Application settings</v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
              <BaseMitLoading :show="loadingOrgs || loadingNetworks || loadingWifis" :overlayFullscreen="false"/>
              <v-card elevation="0" outlined>
                <v-card-title>Meraki Settings</v-card-title>
                <v-card-text>
                  <v-select 
                    :items="merakiOptionsOrgs" 
                    label="Select Organization" 
                    v-model="merakiOrganization"
                    item-text="name"
                    item-value="id"
                    return-object
                    :loading="loadingOrgs"
                    @change="getMerakiNetworks(merakiOrganization.id); merakiWifi = null; merakiNetwork = null; validate()"
                  ></v-select>
                  <v-select 
                    v-if="merakiOrganization" 
                    :items="merakiOptionsNetworks" 
                    label="Select Network" 
                    v-model="merakiNetwork"
                    item-text="name"
                    item-value="id"
                    return-object
                    :loading="loadingNetworks"
                    @change="getMerakiWifis(merakiNetwork.id); merakiWifi = null; validate()"
                  ></v-select>
                  <v-select 
                    v-if="merakiNetwork" 
                    :items="merakiOptionsWifis" 
                    label="WiFi to authorize users on" 
                    v-model="merakiWifi"
                    item-text="ssid"
                    item-value="ssidNumber"
                    return-object
                    :loading="loadingWifis"
                    @change="validate()"
                  ></v-select>
                </v-card-text>
              </v-card>
              <v-btn class="mt-10" @click="saveSettings()" :disabled="!valid">Save</v-btn>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';
  import MitSettingsService from '../../services/MitSettingsService.js';
  import MitMerakiService from '../../services/MitMerakiService.js';

  export default {
    name: 'MitNetworkPage',
    components: {
      BaseMitLoading
    },
    data: function() {
      return {
        status:{
            display:false,
            timeout:3000,
            message:'Saved!',
            color:'primary'
        },
        valid:false,
        loadingOrgs:false,
        loadingNetworks:false,
        loadingWifis:false,
        merakiOptionsOrgs:[],
        merakiOptionsNetworks:[],
        merakiOptionsWifis:[],
        merakiOrganization:null,
        merakiNetwork:null,
        merakiWifi:null,
        settings:null
      }
    },
    created() {
      MitSettingsService.get()
        .then((settings) => {
          this.settings = settings;//store to push back down later upon save

          if(settings.data && settings.data.meraki){
            //pull out the meraki settings we need
            this.merakiOrganization = settings.data.meraki.org;
            this.merakiNetwork = settings.data.meraki.network;
            this.merakiWifi = settings.data.meraki.wifi;

            //refresh the options for any saved states we have
            if(this.merakiOrganization){
              this.getMerakiNetworks(this.merakiOrganization.id);
            }

            if(this.merakiNetwork){
              this.getMerakiWifis(this.merakiNetwork.id);
            }
          }
          
        })
        .catch((error) => {
            console.log('Error getting password validation',error);
        });

        this.getMerakiOrgs();
    },
    mounted() {

    },
    methods: {
      validate(){
        this.valid = true;

        if(this.merakiOrganization === null || this.merakiNetwork === null || this.merakiWifi === null){
          this.valid = false;
        }
      },
      getMerakiOrgs() {
        this.loadingOrgs = true;
        MitMerakiService.getOrganizations()
          .then((orgs) => {
            this.loadingOrgs = false;
            this.merakiOptionsOrgs = orgs;
          })
          .catch((error) => {
            this.loadingOrgs = false;
            console.log('Error getting password validation',error);
          });
        
      },
      getMerakiNetworks(organizationId) {

        this.loadingNetworks = true;
        MitMerakiService.getNetworks(organizationId)
          .then((networks) => {
            this.loadingNetworks = false;
            this.merakiOptionsNetworks = networks;
          })
          .catch((error) => {
            this.loadingNetworks = false;
            console.log('Error getting password validation',error);
          });
        
      },
      getMerakiWifis(networkId) {
        this.loadingWifis = true;
        MitMerakiService.getWifis(networkId)
          .then((wifis) => {
            this.loadingWifis = false;
            this.merakiOptionsWifis = wifis;
          })
          .catch((error) => {
            this.loadingWifis = false;
            console.log('Error getting password validation',error);
          });
      },
      saveSettings() {
          this.settings.data.meraki = {
            org:this.merakiOrganization,
            network:this.merakiNetwork,
            wifi:this.merakiWifi
          }

          MitSettingsService.save(this.settings)
          .then((settings) => {
            if(settings.data && settings.data.meraki){
              this.merakiOrganization = settings.data.meraki.org;
              this.merakiNetwork = settings.data.meraki.network;
              this.merakiWifi = settings.data.meraki.wifi;
            }
            
            this.status.message = 'Saved!';
            this.status.color = 'primary';
            this.status.display = true;
          })
          .catch((error) => {
              console.log('Error getting password validation',error);
              this.status.message = 'An error occurred saving.';
              this.status.color = 'red';
              this.status.display = true;
          });
      }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
